import { render, staticRenderFns } from "./Shareurl.vue?vue&type=template&id=8267fbbc&scoped=true"
import script from "./Shareurl.vue?vue&type=script&lang=js"
export * from "./Shareurl.vue?vue&type=script&lang=js"
import style0 from "./Shareurl.vue?vue&type=style&index=0&id=8267fbbc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8267fbbc",
  null
  
)

export default component.exports